import script from "./BlogLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./BlogLayout.vue?vue&type=script&setup=true&lang=js"

import "./BlogLayout.vue?vue&type=style&index=0&id=28d6e55b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28d6e55b"]])

export default __exports__